import { createFileRoute } from "@tanstack/react-router";
import { FSRSSecondaryNav } from "../../../components/analytics/layout/FSRSSecondaryNav";
import { MainSidebar } from "../../../components/sidebars/MainSidebar";
import { FSRSDocsPage } from "../../../pages/fsrs/FSRSDocsPage";

function FSRSDocsWithSidebar() {
  return (
    <div className="flex h-screen">
      <MainSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <FSRSSecondaryNav />
        <div className="flex-1 overflow-auto p-6">
          <FSRSDocsPage />
        </div>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/admin/fsrs/docs")({
  component: FSRSDocsWithSidebar,
});
